const translations = {
  "en": {
    "Beta": "Beta"
  },
  "zh-tw": {
    "Beta": "Beta"
  }
};

export default translations;
